export const NUMBER_OF_LEARNERS = "40,000+";

export const TERMS_PAGES = [
  { name: "Terms and conditions", link: "/terms-and-conditions/" },
  { name: "Privacy policy", link: "/privacy-policy/" },
  { name: "Refund policy", link: "/refund-policy/" },
  { name: "Reschedule policy", link: "/rescheduling-policy/" },
];

export const DISCLAIMERS = [
  "Spoclearn is a PMI® Premier Authorized Training Partner (ATP) with PMI ID: 6120",
  "PMI®, PMP®, PMBOK®, and the PMI Registered Education Provider logo are registered marks of the Project Management Institute. Inc.",
  "Spoclearn is a PeopleCert Accredited Training Organization (ATO) with PeopleCert ID: 7822",
  "ITIL® is a registered trademark of AXELOS Limited, used under permission of AXELOS Limited",
  "PRINCE2® is a registered trademark of AXELOS Limited, used under permission of AXELOS Limited",
  "The Swirl logoTM is a trademark of AXELOS Limited, used under permission of AXELOS Limited. All rights reserved",
  "Spoclearn is accredited as a Registered Authorized Partner of DevOps Institute",
  "Spoclearn is an Accredited Training Organization (ATO) of EXIN for all their certification courses and exams",
];

export const PHONES = [
  {
    label: "India: +91 83417-05065",
    value: "+918341705065",
    country: "IN",
  },
  {
    label: "USA: +1 (908) 293 7144",
    value: "+19082937144",
    country: "US",
  },
  {
    label: "UK: +44 131 381 3655",
    value: "+441313813655",
    country: "GB",
  },
  {
    label: "HK: +852 30011418",
    value: "+85230011418",
    country: "HK",
  },
];

export const FOOTER_LINLS = [
  {
    title: "Company",
    links: [
      { label: "Courses", link: "/courses/" },
      { label: "About us", link: "/about-us/" },
      { label: "1 to 1 Training", link: "/one-to-one-training/" },
      { label: "Reviews", link: "/review-testimonials/" },
      { label: "Accreditations", link: "/accreditations/" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Blogs", link: "/blog" },
      { label: "Consulting", link: "/consulting/" },
      { label: "News", link: "/news/" },
    ],
  },
  {
    title: "Quick links",
    links: [
      { label: "Contact us", link: "/contact-us/" },
      { label: "Sitemap", link: "/sitemap/" },
      { label: "Corporate training", link: "/corporate-training/" },
    ],
  },
  {
    title: "Join us",
    links: [{ label: "Become an instructor", link: "/join-us-as-a-trainer/" }],
  },
];

export const TRUSTED_COMPANIES = [
  { src: "/images/companies/tcs.webp", alt: "tcs" },
  { src: "/images/companies/microsoft.webp", alt: "microsoft" },
  { src: "/images/companies/ibm.webp", alt: "ibm" },
  { src: "/images/companies/meta.webp", alt: "meta" },
  { src: "/images/companies/infosys.webp", alt: "infosys" },
  { src: "/images/companies/bosch.webp", alt: "bosch" },
  { src: "/images/companies/amazon.webp", alt: "amazon" },
  { src: "/images/companies/nvidia.webp", alt: "nvidia" },
];
